module.exports = __webpack_public_path__ + "img/AI.ac39a56c.svg";